module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "project project--external",
    class: 'size-' + _vm.tiles
  }, [_c('a', {
    attrs: {
      "href": _vm.link,
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('div', {
    staticClass: "project-logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.logo,
      "alt": _vm.title
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('h2', [_vm._v(_vm._s(_vm.title))])])]), _vm._v(" "), _c('div', {
    staticClass: "preview"
  }, [_c('img', {
    attrs: {
      "src": _vm.preview,
      "alt": _vm.title + ' Preview'
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "blender-1",
    style: ({
      background: _vm.background
    })
  }), _vm._v(" "), _c('span', {
    staticClass: "blender-2",
    style: ({
      background: _vm.background
    })
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21dcd37c"}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/partials/project-external.vue
// module id = 66
// module chunks = 0